import { render } from "./PeopleAssignedToShipmentAlert.vue?vue&type=template&id=2ede548e"
import script from "./PeopleAssignedToShipmentAlert.vue?vue&type=script&lang=js"
export * from "./PeopleAssignedToShipmentAlert.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__